import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate, useSearchParams } from 'react-router';
import { useGetUserVerifyEmail } from '@/lib/api/use-get-user-verify-email';
import { useEffect, useState } from 'react';
import { ErrorToResendEmail } from './components/error-to-resend-email';
import { NstButton, NstIcon, NstLoading, NstText } from '@nstechhub/nsds-react';

export default function ConfirmAccount() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const userId = searchParams.get('userId');

  const { isLoading, isSuccess, error } = useGetUserVerifyEmail({
    token: token!,
  });

  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (!isSuccess) return;

    if (countdown <= 0) {
      navigate('/');
      return;
    }

    const interval = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown, isSuccess, navigate]);

  if (isLoading) {
    return (
      <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4'>
        <NstLoading size='xl' />
      </div>
    );
  }

  if (error) {
    return <ErrorToResendEmail email={email!} userId={userId!} />;
  }

  if (isSuccess) {
    return (
      <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4'>
        <Card className='w-full max-w-xl'>
          <CardHeader className='text-center space-y-4'>
            <div className='mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center'>
              <NstIcon name='circle-check-big' size='lg' color='success' />
            </div>
            <div className='space-y-2'>
              <CardTitle className='text-2xl font-bold text-gray-900'>
                Conta Confirmada!
              </CardTitle>
            </div>
          </CardHeader>

          <CardContent className='space-y-6'>
            <div className='flex items-center justify-center space-x-2 text-sm text-gray-600 text-center space-y-4'>
              <span>
                <NstText> Conta ativada com sucesso para o usuário</NstText>
                <NstText level='body' weight='bold'>
                  {email ?? ''}
                </NstText>
              </span>
            </div>

            {countdown > 0 && (
              <div className='flex flex-col items-center justify-center space-x-2 text-sm text-gray-600 text-center space-y-4'>
                <span>
                  <NstText>
                    Um e-mail com uma senha temporária foi enviado para você.
                  </NstText>
                </span>
                <span>
                  <NstText>
                    Você será redirecionado automaticamente para o login em
                  </NstText>
                  <NstText
                    level='body'
                    weight='bold'
                  >{`${countdown} segundos`}</NstText>
                </span>
                <NstText> Ou clique no botão abaixo. </NstText>
              </div>
            )}

            <div className='space-y-3 flex justify-center'>
              <NstButton
                variant='primary'
                size='lg'
                onClick={() => navigate('/')}
              >
                Acessar Minha Conta
              </NstButton>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}
